import { ReactNode } from "react";
import { Link } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { sizes, space } from "et3-ui-library";

import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";

const NavItem = withLiteObserverAndTheme<{
  title: string;
  link: string;
  icon: ReactNode;
  isSelected: boolean;
  isNested: boolean;
  onNavigate: () => void;
}>((props) => {
  const { title, link, icon, isSelected, isNested, onNavigate } = props;

  return (
    <ListItemButton
      component={Link}
      to={link}
      selected={isSelected}
      onClick={onNavigate}
      sx={isNested ? { pl: `${space(2) + sizes.listItemIcon}px` } : undefined}
    >
      {isNested ? null : <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText primary={title} />
    </ListItemButton>
  );
});
export default NavItem;
